import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

interface Props {
	countries: Array<string>;
	utilities?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MapCountries',
  props: {
    countries: {},
    utilities: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const mapContainer = ref<HTMLElement | null>(null);
let map: mapboxgl.Map | null = null;
const center = ref([12, 49]);

const mapboxApi = computed(() => import.meta.env.VITE_MAPBOX_API ?? "");

const setCountryFilter = () => {
	if (!map || !props.countries?.length) return;

	const countryFilter = ["in", "iso_3166_1_alpha_3", ...props.countries];

	if (map.getLayer("country-fill")) {
		map.setFilter("country-fill", countryFilter);
	}
	if (map.getLayer("country-lines")) {
		map.setFilter("country-lines", countryFilter);
	}
};

onMounted(() => {
	if (!mapContainer.value) return;

	mapboxgl.accessToken = mapboxApi.value;
	map = new mapboxgl.Map({
		container: mapContainer.value,
		style: "mapbox://styles/mapbox/light-v11",
		center: center.value,
		zoom: 4,
		scrollZoom: false,
		projection: { name: "mercator" },
	});

	map.addControl(new mapboxgl.NavigationControl(), "bottom-left");

	map.on("load", () => {
		map?.addSource("country-boundaries", {
			type: "vector",
			url: "mapbox://mapbox.country-boundaries-v1",
		});

		map?.addLayer({
			id: "country-fill",
			source: "country-boundaries",
			"source-layer": "country_boundaries",
			type: "fill",
			paint: {
				"fill-color": "#EE730A",
				"fill-opacity": 0.4,
			},
		});

		map?.addLayer({
			id: "country-lines",
			source: "country-boundaries",
			"source-layer": "country_boundaries",
			type: "line",
			paint: {
				"line-color": "#EE730A",
				"line-width": 2,
			},
		});

		setCountryFilter();
	});
});

watch(
	() => props.countries,
	() => {
		setCountryFilter();
	},
	{ deep: true },
);

onUnmounted(() => {
	if (map) {
		map.remove();
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative flex h-[30vh] w-full flex-col overflow-hidden rounded-3xl md:h-[50vh]", __props.utilities])
  }, [
    _createElementVNode("div", {
      ref_key: "mapContainer",
      ref: mapContainer,
      class: "h-full w-full grow"
    }, null, 512)
  ], 2))
}
}

})